import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { BlogPost } from "./blog.model";

const ACTION_PREFIX = "[Blog]";

export const BLOG_ACTION_TYPE = {
	getFeed: `${ACTION_PREFIX} Get Feed`,
	getFeedSuccess: `${ACTION_PREFIX} Get Feed Success`,
	getFeedFail: `${ACTION_PREFIX} Get Feed Fail`,
};

/**
 * @deprecated [fabric-deprecated] - use fabric BlogService from app-site instead
 */
@Injectable({
	providedIn: "root",
})
export class BlogAction {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(SiteAppCommand.GetAllBlogPosts)" instead
	 */
	getFeed(count?: number): Action {
		return createCachedGetAction({
			type: BLOG_ACTION_TYPE.getFeed,
			payload: count || undefined,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(SiteAppCommand.GetAllBlogPosts)" instead
	 */
	getFeedSuccess(posts: BlogPost[]): ActionWithPayload {
		return createGetSuccessAction({
			type: BLOG_ACTION_TYPE.getFeedSuccess,
			payload: posts,
		});
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(SiteAppCommand.GetAllBlogPosts)" instead
	 */
	getFeedFail(error: AppError): ActionWithPayload {
		return {
			type: BLOG_ACTION_TYPE.getFeedFail,
			payload: error,
		};
	}
}
